import React from 'react';
import { Typography } from '@mui/material';
import { titleStyles } from '../../WorkflowResponseForm/WorkflowResponseForm.styles';

interface RequestFormTitleProps {
  title: string;
}

const RequestFormTitle: React.FC<RequestFormTitleProps> = ({ title }) => (
  <Typography
    variant="h4"
    component="h1"
    sx={{
      ...titleStyles,
      flex: 1,
      letterSpacing: '-0.01em',
      m: 0,
      textAlign: 'center',
    }}
  >
    {title}
  </Typography>
);

export default RequestFormTitle;
